// URL de base du backend Drupal.
//
// Priority:
//   1. VITE_DRUPAL_BASE_URL (build-time) — set in .env for local dev, or as an explicit Upsun
//      variable when the "drupal." prefix convention cannot be used.
//   2. Runtime derivation — prepends "drupal." to window.location.hostname.
//      Works automatically on Upsun without any manual per-environment variable:
//      e.g. https://main-xxx.eu.platformsh.site → https://drupal.main-xxx.eu.platformsh.site
//   3. DDEV hardcoded fallback — covers SSR/test contexts where window is unavailable.
const _runtimeDrupalUrl = typeof window !== 'undefined'
  ? `${window.location.protocol}//drupal.${window.location.hostname}`
  : 'https://drupal.orbit.ddev.site';

export const DRUPAL_BASE_URL = import.meta.env.VITE_DRUPAL_BASE_URL || _runtimeDrupalUrl;
